import React from 'react';

export default function Step3FitnessGoal({ formData, setFormData, onNext }) {
  const { Goal, FitnessExperience, TrainingDaysPerWeek } = formData;

  const isValid = Goal !== null && FitnessExperience !== null && TrainingDaysPerWeek !== '';

  return (
    <div className="space-y-6">
      <h2 className="text-lg font-bold mb-4">هدف تمرینی و سابقه</h2>

      {/* هدف */}
      <div>
        <label className="block text-sm mb-1">هدف شما:</label>
        <select
          value={Goal ?? ''}
          onChange={(e) => setFormData({ ...formData, Goal: parseInt(e.target.value) })}
className="w-full p-3 rounded-xl border-2 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:border-gray-600 bg-white dark:bg-[#2a2f3b] transition"
        >
          <option value="">انتخاب کنید...</option>
          <option value="0">کاهش وزن</option>
          <option value="1">عضله‌سازی</option>
          <option value="2">تناسب اندام عمومی</option>
          <option value="3">افزایش قدرت</option>
          <option value="4">افزایش استقامت</option>
          <option value="5">بازتوانی</option>
        </select>
      </div>

      {/* سابقه تمرینی */}
      <div>
        <label className="block text-sm mb-1">سابقه تمرینی:</label>
        <select
          value={FitnessExperience ?? ''}
          onChange={(e) => setFormData({ ...formData, FitnessExperience: parseInt(e.target.value) })}
className="w-full p-3 rounded-xl border-2 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:border-gray-600 bg-white dark:bg-[#2a2f3b] transition"
        >
          <option value="">انتخاب کنید...</option>
          <option value="0">بدون سابقه</option>
          <option value="1">مبتدی</option>
          <option value="2">متوسط</option>
          <option value="3">پیشرفته</option>
        </select>
      </div>

      {/* روزهای تمرین در هفته */}
      <div>
        <label className="block text-sm mb-1">تعداد روز تمرین در هفته:</label>
<input
  type="number"
  value={formData.TrainingDaysPerWeek}
  min={1}
  max={4}
  onChange={(e) => {
    const val = parseInt(e.target.value);
    if (val >= 1 && val <= 4) {
      setFormData({ ...formData, TrainingDaysPerWeek: val });
    } else {
      setFormData({ ...formData, TrainingDaysPerWeek: '' });
    }
  }}
  className="w-full p-2 rounded border dark:border-gray-600 bg-white dark:bg-[#2a2f3b]"
  placeholder="بین 1 تا 4 روز در هفته"
/>

      </div>

      <div className="text-right">
        <button
          onClick={onNext}
          disabled={!isValid}
          className="w-full p-3 bg-blue-600 rounded-xl border-2 hover:bg-blue-700 text-white px-6 py-2 rounded-xl disabled:opacity-50"
        >
          مرحله بعد
        </button>
      </div>
    </div>
  );
}
